import { PostHogFeatureFlag, useFeatureFlag } from '#~/posthog/index.js';
import type { ReactElement } from 'react';
import type { TriggersProps } from './types.js';
import { Tab } from './types.js';
import { Icon } from '@studio/design-system/icon';
import * as Tabs from '@studio/design-system/tabs';
import { twMerge } from 'cn';
import { Sel, STagNew } from '#~/stag/index.js';

/** @internal */
export const Triggers = ({
  children,
  className,
  disabled,
  ...props
}: TriggersProps): ReactElement => {
  const { enabled: autotrackingEnabled } = useFeatureFlag(PostHogFeatureFlag.AUTOTRACKING, {
    defaultValue: false
  });

  return (
    <Tabs.List className={twMerge('min-h-[40px]', className)} {...props}>
      <Tabs.Trigger
        disabled={disabled}
        value={Tab.Presets}
        {...STagNew(Sel.MainRoomBottomTrayPresets, 'tab')}
      >
        <Icon icon='preset-position' />
        Position Presets
      </Tabs.Trigger>

      {autotrackingEnabled && (
        <Tabs.Trigger disabled={disabled} value={Tab.Tracking}>
          <Icon icon='auto-tracking' />
          Auto Tracking
        </Tabs.Trigger>
      )}
      {children}
    </Tabs.List>
  );
};
